import React, { useState, useEffect } from 'react';
import '../../styles//crud.css';
import '../../styles//botones_dflt.css';
import Spinner from "../spinner";
import { cargarCompanias , crearCompania , obtenerCompania , eliminarCompania , eliminarTelefono , eliminarCorreo , actualizarCompania } from '../../services/apiCompanias.js';
import * as apiCompanias from '../../services/apiCompanias.js';
import * as apiRamos from '../../services/apiRamos.js';
import * as alerts from '../../functions/alerts.js';


const CrudTable = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]); // Estado para almacenar filas
  const [formData, setFormData] = useState({ nombre: '' ,apellido: '',direccion: '', telefonos: '', correos: '', ramos: ''}); // Estado del formulario
  const [telefonos, setTelefonos] = useState([]); // Estado para almacenar filas
  const [correos, setCorreos] = useState([]); // Estado para almacenar filas
  const [isFormModalOpen, setIsFormModalOpen] = useState(false); // Control del modal de ingreso/edición
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); // Control del modal de eliminación
  const [deleteIndex, setDeleteIndex] = useState(null); // Índice de la fila a eliminar
  const [isEditing, setIsEditing] = useState(false); // Estado para editar
  const [editIndex, setEditIndex] = useState(null); // Índice de la fila a editar
  const [ramos, setRamos] = useState([]);
  
  // Cargar datos desde la API al montar el componente
    const fetchData = async () => {
        try{
          const json = await cargarCompanias();
          console.log(json);
          const formattedData = json.companias.map((item) => ({
          id: item.id,
            nombre: item.nombre,
            ruc: item.ruc,
            direccion: item.direccion,
          }));
          setData(formattedData);
          setLoading(false);
        } catch (error) {
          console.error('Error al cargar los datos:', error);
      }
    };

  const storedUser = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
      fetchData();
    }, []);

  // Manejar los cambios en los campos del formulario
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Abrir el modal de formulario para agregar o editar
  const openFormModal = async (index = null) => {
    if (index !== null) {
      try {
        const jsonCli = await obtenerCompania(data[index].id);
        console.log(jsonCli);
        if(jsonCli){
          const formattedData = ({
            id: jsonCli.id,
            ruc: jsonCli.ruc,
            nombre: jsonCli.nombre,
            direccion: jsonCli.direccion
          });
          setFormData(formattedData);
          setTelefonos(jsonCli.telefonos);
          setCorreos(jsonCli.correos);
          setRamos(jsonCli.ramos);
        }
      } catch (error) {
        console.error('Error al cargar los datos:', error);
      }
      //setFormData(data[index]);  Cargar datos existentes si es edición
      setIsEditing(true);
      setEditIndex(data[index].id);
    } else {
      setFormData({ nombre: '' ,ruc: '',direccion: '', telefonos: '', correos: '', ramos: ''}); 
      setTelefonos([]);
      setCorreos([]);
      setRamos([]);
      setIsEditing(false);
    }
    setIsFormModalOpen(true);
  };

  // Cerrar el modal de formulario
  const closeFormModal = () => {
    fetchData();
    setIsFormModalOpen(false);
  };

  // Guardar datos (Agregar o Editar)
  async function handleFormSubmit(e) {
    e.preventDefault();
    if (isEditing) {
      try {
//gestion de compania
        const response = await actualizarCompania(formData, storedUser, editIndex);
        if (response.ok) {
//gestion de compania
//-----------------------------------------
//gestion de telefonos
          const nuevosTelefonos = telefonos.filter((elemento) => !elemento.id);
          const resultados = await Promise.all(
            nuevosTelefonos.map((elemento) => { 
              return apiCompanias.agregarTelefono(elemento, editIndex, storedUser);  
            })
          );
          resultados.forEach((response) => {
            if (!response.ok) {
              console.error('Error al crear teléfono:', response.statusText);
            }
          });
          const telefonosExistentes = telefonos.filter((elemento) => elemento.id);
          const resultados_upd_telf = await Promise.all(
            telefonosExistentes.map((elemento) => { 
              return apiCompanias.actualizarTelefono(elemento, storedUser);  
            })
          );
          resultados_upd_telf.forEach((response) => {
            if (!response.ok) {
              console.error('Error al editar el teléfono:', response.statusText);
            }
          });
//gestion de telefonos
//-----------------------------------------
//gestion de correos
          const nuevosCorreos = correos.filter((elemento) => !elemento.id);
          const resultados_add_corr = await Promise.all(
            nuevosCorreos.map((elemento) => { 
              return apiCompanias.agregarCorreo(elemento, editIndex,storedUser);  
            })
          );
          resultados_add_corr.forEach((response) => {
            if (!response.ok) {
              console.error('Error al agregar el correo:', response.statusText);
            }
          });
          const correosExistentes = correos.filter((elemento) => elemento.id);
          const resultados_upd_corr = await Promise.all(
            correosExistentes.map((elemento) => { 
              return apiCompanias.actualizarCorreo(elemento, storedUser);  
            })
          );
          resultados_upd_corr.forEach((response) => {
            if (!response.ok) {
              console.error('Error al editar el correo:', response.statusText);
            }
          });
//gestion de correos
//-----------------------------------------
//gestion de ramos
          const nuevosRamos = ramos.filter((elemento) => !elemento.id);
          const resultados_add_ramo = await Promise.all(
            nuevosRamos.map((elemento) => { 
              return apiRamos.crearRamo(elemento, editIndex, storedUser);  
            })
          );
          resultados_add_ramo.forEach((response) => {
            if (!response.ok) {
              console.error('Error al crear el ramo:', response.statusText);
            }
          });
          const ramosExistentes = ramos.filter((elemento) => elemento.id);
          const resultados_upd_ramos = await Promise.all(
            ramosExistentes.map((elemento) => { 
              return apiRamos.actualizarRamo(elemento, storedUser);  
            })
          );
          resultados_upd_ramos.forEach((response) => {
            if (!response.ok) {
              console.error('Error al editar el ramo:', response.statusText);
            }
          });
//gestion de ramos
          alerts.handleSuccess('Éxito!','Cambios guardados correctamente')
        } else {
          console.error('Error al guardar cambios:', response.statusText);
        }
      } catch (error) {
        console.error('Error al hacer la solicitud:', error);
      }
    } else {
      const response = await crearCompania(formData, telefonos, correos, storedUser, ramos);
      if (response.ok) {
        const data = await response.json();
        const nuevoCliente=data.cliente_id;
        console.log(nuevoCliente)
        alerts.handleSuccess('Éxito!','Compañía creada correctamente')
        setIsFormModalOpen(false);
      } else {
        console.error('Error al agregar nueva compañía:', response.statusText);
      }
    }
    closeFormModal();
  }

  const handleChangeTelf = (index, field, value) => {
    const nuevosTelefonos = [...telefonos];
    nuevosTelefonos[index][field] = value; // Actualiza el campo específico
    setTelefonos(nuevosTelefonos);
  };

  const handleChangeCorr = (index, field, value) => {
    const nuevosCorreos = [...correos];
    nuevosCorreos[index][field] = value; // Actualiza el campo específico
    setCorreos(nuevosCorreos);
  };

  const handleChangeRamo = (index, field, value) => {
    const nuevosRamos = [...ramos];
    nuevosRamos[index][field] = value; // Actualiza el campo específico
    setRamos(nuevosRamos);
  };

  const openDeleteModal = (index) => {
    setDeleteIndex(index);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const confirmDelete = async () => {
    const response = await eliminarCompania(data[deleteIndex].id,storedUser);
    if (response.ok) {
      alerts.handleSuccess('Éxito!','Compañía eliminada correctamente')
    } else {
      console.error('Error al eliminar la compañía:', response.statusText);
    }
    fetchData();
    closeDeleteModal();
  };

  const handleDeleteTelf = async (index) => {
    if (telefonos[index].id){
        const response = await eliminarTelefono(telefonos[index].id,storedUser)
        if (response.ok) {
          alerts.handleSuccess('Éxito!','Telefono eliminado correctamente')
        } else {
          console.error('Error al eliminar el telefono:', response.statusText);
        }
    }
    setTelefonos((prevTelefonos) => prevTelefonos.filter((_, i) => i !== index));        
  };

  const agregarTelefono = () => {
    setTelefonos([...telefonos, { telefono: "", descripcion: "" }]);
  };

  const handleDeleteCorr = async (index) => {
    if (correos[index].id){
        const response = await eliminarCorreo(correos[index].id,storedUser)
        if (response.ok) {
          alerts.handleSuccess('Éxito!','Correo eliminado correctamente')
        } else {
          console.error('Error al eliminar el correo:', response.statusText);
        }
    }
    setCorreos((prevCorreos) => prevCorreos.filter((_, i) => i !== index));        
  };

  const agregarCorreo = () => {
    setCorreos([...correos, { correo: "", descripcion: "" }]);
  };

    const handleDeleteRamo = async (index) => {
    if (ramos[index].id){
        const response = await apiRamos.eliminarRamo(ramos[index].id,storedUser)
        if (response.ok) {
          alerts.handleSuccess('Éxito!','Ramo eliminado correctamente')
        } else {
          console.error('Error al eliminar el ramo:', response.statusText);
        }
    }
    setRamos((prevRamos) => prevRamos.filter((_, i) => i !== index));        
  };

  const agregarRamo = () => {
    setRamos([...ramos, { nombre: ""}]);
  };

  return (
    <div className="crud-table">
    {!loading && <button className='button_new' onClick={() => openFormModal()}>Añadir Nueva Compañía</button>}
      {/* Tabla */}
      {loading ? <Spinner /> :
      <table>
        <thead>
          <tr>
            <th>RUC</th>
            <th>Nombre</th>
            <th>Dirección</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((item, index) => (
              <tr key={item.id}>
                <td>{item.ruc}</td>
                <td>{item.nombre}</td>
                <td>{item.direccion}</td>
                <td>
                  <button className="editar" onClick={() => openFormModal(index)}>Editar</button>
                  <button className="eliminar" onClick={() => openDeleteModal(index)}>Eliminar</button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5">No hay datos</td>
            </tr>
          )}
        </tbody>
      </table>}

      {/* Modal de Formulario */}
      {isFormModalOpen && (
        <div className="modal">
          <div className="modal-content modal-content-wide">
            <h2>{isEditing ? 'Editar Compañía' : 'Añadir Compañía'}</h2>
            <table>
              <tbody>
                <tr>
                  <td className='modal-region'>
                    <h3>Información General</h3>
                    <form onSubmit={handleFormSubmit} className='form_crud'>
                      <input
                        type="text"
                        name="ruc"
                        placeholder="RUC"
                        value={formData.ruc}
                        onChange={handleChange}
                        required
                      />
                      <input
                        type="text"
                        name="nombre"
                        placeholder="Nombre Compañía"
                        value={formData.nombre}
                        onChange={handleChange}
                        required
                      />
                      <input
                        type="text"
                        name="direccion"
                        placeholder="Dirección"
                        value={formData.direccion}
                        onChange={handleChange}
                      />
                    </form>
                  </td>
                  <td className='modal-region'>
                  <button className='button_new' onClick={agregarTelefono}>Añadir Teléfono</button>
                    {/* Tabla Telefonos */}
                  
                    {telefonos.length > 0 && (
                          <table >
                          <tbody>
                              {telefonos.map((telefono, index) => (
                              <tr key={index}>
                                  <td>
                                  <input
                                      type="text"
                                      id="telefono"
                                      name="telefono"
                                      value={telefono.telefono}
                                      onChange={(e) => handleChangeTelf(index, "telefono", e.target.value)}
                                      placeholder="Teléfono"
                                  />
                                  </td>
                                  <td><input
                                      type="text"
                                      id="descripcion"
                                      name="descripcion"
                                      value={telefono.descripcion}
                                      onChange={(e) => handleChangeTelf(index, "descripcion", e.target.value)}
                                      placeholder="Descripción"
                                  /></td>
                                  <td>
                                  <button onClick={() => handleDeleteTelf(index)}>X</button>
                                  </td>
                              </tr>
                              ))}
                          </tbody>
                          </table>  
                    )}
                  </td>
                  </tr>
                  <tr>
                  <td className='modal-region'>
                    <button className='button_new' onClick={agregarCorreo}>Añadir Correo</button>
                    {/* Tabla Correos */}
                    {correos.length > 0 && (
                        <table >
                        <tbody>
                            {correos.map((correos, index) => (
                            <tr key={index}>
                                <td>
                                <input
                                    type="text"
                                    id="correos"
                                    name="correos"
                                    value={correos.correo}
                                    onChange={(e) => handleChangeCorr(index, "correo", e.target.value)}
                                    placeholder="Correo"
                                />
                                </td>
                                <td><input
                                    type="text"
                                    id="descripcion"
                                    name="descripcion"
                                    value={correos.descripcion}
                                    onChange={(e) => handleChangeCorr(index, "descripcion", e.target.value)}
                                    placeholder="Descripción"
                                /></td>
                                <td>
                                <button onClick={() => handleDeleteCorr(index)}>X</button>
                                </td>
                            </tr>
                            ))}
                        </tbody>
                        </table>  
                    )}
                  </td>
                  <td className='modal-region'>
                    <button className='button_new' onClick={agregarRamo}>Añadir Ramo</button>
                    {/* Tabla Ramos */}
                    {ramos.length > 0 && (
                        <table >
                        <tbody>
                            {ramos.map((ramos, index) => (
                            <tr key={index}>
                                <td>
                                <input
                                    type="text"
                                    id="nombre"
                                    name="nombre"
                                    value={ramos.nombre}
                                    onChange={(e) => handleChangeRamo(index, "nombre", e.target.value)}
                                    placeholder="Nombre"
                                /></td>
                                <td>
                                <button onClick={() => handleDeleteRamo(index)}>X</button>
                                </td>
                            </tr>
                            ))}
                        </tbody>
                        </table>  
                    )}
                  </td>
                  </tr>
                </tbody>
            </table>
            <button type="submit" className='guardar' onClick={handleFormSubmit}>{isEditing ? 'Actualizar' : 'Añadir'}</button>
            <button type="button" className='cancelar' onClick={closeFormModal}>Cancelar</button>
          </div>
        </div>
      )}

      {/* Modal de Confirmación de Eliminación */}
      {isDeleteModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h2>Confirmar Eliminación</h2>
            <p>¿Estás seguro de que deseas eliminar este registro?</p>
            <button onClick={confirmDelete}>Sí, eliminar</button>
            <button onClick={closeDeleteModal}>Cancelar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CrudTable;